// extracted by mini-css-extract-plugin
export default {"about-container":"AboutUs_about-container__gWJMg","about-text":"AboutUs_about-text__KelQF","contact-info":"AboutUs_contact-info__qEp6+","info-icon":"AboutUs_info-icon__cots2"};